import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import confetti from 'canvas-confetti';

const HUBS = [
  { code: 'KLAX', name: 'Los Angeles (LAX)' },
  { code: 'KJFK', name: 'New York (JFK)' },
  { code: 'KORD', name: 'Chicago (ORD)' },
  { code: 'KDFW', name: 'Dallas/Fort Worth (DFW)' },
  { code: 'KATL', name: 'Atlanta (ATL)' },
  { code: 'KSFO', name: 'San Francisco (SFO)' },
  { code: 'KSEA', name: 'Seattle (SEA)' },
  { code: 'KDEN', name: 'Denver (DEN)' },
];

export default function StepHub({ form, setForm, back }) {
  const navigate = useNavigate();
  const canProceed = form.hub !== null;

  const handleLaunch = () => {
    if (!canProceed) return;

    const newAirline = {
      id: Date.now(),
      name: form.name,
      iataCode: form.iata,
      hub: form.hub,
      logo: form.logoId,
      colors: form.colors,
      livery: {
        base: '787',
        id: form.liveryId,
      },
      reputation: 50,
      reputationTier: 'startup',
      phase: 1,
    };

    localStorage.setItem('playerAirline', JSON.stringify(newAirline));
    
    // Fire confetti
    const duration = 3000;
    const end = Date.now() + duration;

    const frame = () => {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: ['#00ffbf', '#0088ff', '#ffffff'],
      });
      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: ['#00ffbf', '#0088ff', '#ffffff'],
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };

    frame();
    
    setTimeout(() => {
      navigate('/worldmap');
    }, 500);
  };

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-light mb-2" style={{ color: 'var(--text-primary)' }}>
          Home Hub
        </h1>
        <p className="text-sm font-light" style={{ color: 'var(--text-secondary)' }}>
          Select your airline's primary hub airport.
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="hub" className="text-sm font-normal" style={{ color: 'var(--text-secondary)' }}>
          Airport
        </Label>
        <Select 
          value={form.hub || ''} 
          onValueChange={(value) => setForm({ ...form, hub: value })}
        >
          <SelectTrigger className="rounded-sm" style={{ backgroundColor: 'var(--bg-panel)', borderColor: 'var(--border)', color: 'var(--text-primary)' }}>
            <SelectValue placeholder="Select hub airport" />
          </SelectTrigger>
          <SelectContent className="rounded-sm" style={{ backgroundColor: 'var(--bg-card)', borderColor: 'var(--border)', color: 'var(--text-primary)' }}>
            {HUBS.map((hub) => (
              <SelectItem key={hub.code} value={hub.code} className="font-light">
                {hub.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {form.hub && (
        <div className="p-6 rounded-sm" style={{ borderWidth: '1px', borderColor: 'var(--border)', backgroundColor: 'var(--bg-panel)' }}>
          <div className="text-xs font-light mb-4" style={{ color: 'var(--text-muted)' }}>AIRLINE SUMMARY</div>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="font-light" style={{ color: 'var(--text-secondary)' }}>Name</span>
              <span className="font-normal" style={{ color: 'var(--text-primary)' }}>{form.name}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-light" style={{ color: 'var(--text-secondary)' }}>IATA Code</span>
              <span className="font-normal" style={{ color: 'var(--text-primary)' }}>{form.iata}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-light" style={{ color: 'var(--text-secondary)' }}>Hub</span>
              <span className="font-normal" style={{ color: 'var(--text-primary)' }}>
                {HUBS.find(h => h.code === form.hub)?.name}
              </span>
            </div>
          </div>
        </div>
      )}

      <div className="flex justify-between pt-4" style={{ borderTopWidth: '1px', borderColor: 'var(--border)' }}>
        <Button
          onClick={back}
          variant="outline"
          className="font-normal px-8 rounded-sm"
          style={{ borderColor: 'var(--border)', color: 'var(--text-primary)' }}
        >
          Back
        </Button>
        <Button
          onClick={handleLaunch}
          disabled={!canProceed}
          className="font-normal px-8 rounded-sm"
          style={{ backgroundColor: 'var(--neon)', color: '#000' }}
        >
          Launch Airline
        </Button>
      </div>
    </div>
  );
}